export default "__VITE_ASSET__122ddpz9__"